<script setup lang="ts">
import { ref, onMounted, computed, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="seatMap-wrapper">
    <div class="desktop-view d-none d-md-block">
      <img src="@/assets/objects/seat plan flat.png" alt="Seat Plan" class="desktop-seat-map"/>
    </div>
    <div class="mobile-view d-block d-md-none">
      <img src="@/assets/objects/seat plan flat.png" alt="Seat Plan" class="mobile-seat-map"/>
    </div>
  </div>
</template>

<style scoped>
.seatMap-wrapper {
  position: relative;
  width: 100%;
  min-height: 200px;
  margin-top: 1rem;
  margin-bottom: 5rem;
}

.desktop-view, .mobile-view {
  padding: 1rem;
  background: rgba(0, 0, 0, 0.5) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  box-shadow: #76c4ae 0 0, #76c4ae80 0 0;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  margin: 1rem 0;
}

.desktop-view:hover, .mobile-view:hover {
  box-shadow: rgba(118, 196, 174, 0.3) -10px 10px, rgba(118, 196, 174, 0.2) -20px 20px !important;
}

.desktop-seat-map {
  width: 100%;
  height: auto;
  display: block;
}

.mobile-seat-map {
  width: 130%;
  margin-left: -13vw;
  margin-top: 5vh;
  height: auto;
  display: block;
  transform: rotate(90deg);
  transform-origin: center;
  max-width: unset;
  position: relative;
}

.mobile-view {
  width: 100%;
  position: relative;
  height: max-content;
  margin: 1rem 0;
  padding: 2rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .seatMap-wrapper {
    margin-bottom: 2rem;
    margin-top: 1rem;
    padding: 0 1rem;
  }
}

@media (max-width: 960px) {
  .mobile-seat-map {
  transform: rotate(90deg) scale(1);
  margin-top: 18vh;
  margin-left: -11.1vw;
}

.mobile-view {
  width: 100%;
  position: relative;
  height: auto;
  min-height: 85vh;
  margin: 1rem 0;
  padding: 2rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
}




@media (max-width: 600px) {
  .mobile-seat-map {
  transform: rotate(90deg) scale(1.5);
  margin-top: 19vh;
  margin-left: -11.1vw;
}

.mobile-view {
  width: 112%;
  position: relative;
  height: auto;
  min-height: 70vh;
  margin: 1rem 0;
  margin-left: -5vw;
  padding: 2rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
}

@media (max-width: 400px) {
  .mobile-seat-map {
  transform: rotate(90deg) scale(1.6);
  margin-top: 23vh;
  margin-left: -11.1vw;
}

.mobile-view {
  width: 112%;
  position: relative;
  height: auto;
  min-height: 85vh;
  margin: 1rem 0;
  margin-left: -5vw;
  padding: 2rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
}
</style>
